/** Backend promo middleware: 8–128 chars, charset A-Z a-z 0-9 . _ - (no `:`). */
export function sanitizePromoIdempotencySegment(value: string): string {
  return value.replace(/[^A-Za-z0-9._-]/g, '-');
}

function truncatePromoIdempotencyKey(value: string): string {
  return value.length <= 128 ? value : value.slice(0, 128);
}

export function buildCustomerPromoApplyIdempotencyKey(
  checkoutSessionId: string,
  normalizedCode: string,
): string {
  return truncatePromoIdempotencyKey(
    `promotions-apply-code-${sanitizePromoIdempotencySegment(checkoutSessionId)}-${sanitizePromoIdempotencySegment(normalizedCode)}`,
  );
}

export function buildCustomerPromoRemoveIdempotencyKey(checkoutSessionId: string): string {
  return truncatePromoIdempotencyKey(
    `promotions-remove-code-${sanitizePromoIdempotencySegment(checkoutSessionId)}`,
  );
}

export function buildCustomerPromoExclusiveRemoveIdempotencyKey(checkoutSessionId: string): string {
  return truncatePromoIdempotencyKey(
    `promotions-remove-code-exclusive-${sanitizePromoIdempotencySegment(checkoutSessionId)}`,
  );
}
